export default __webpack_public_path__ + "static/media/office.c55d48f2.jpg";